module.exports = __webpack_public_path__ + "img/korea.6770c50e.svg";